<template>
  <div>
    <AddressBookTable />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AddressBookTable from '@/views/Components/AddressBook/AddressBookTable.vue'

export default defineComponent({
  name: 'AddressBookPage',
  components: { AddressBookTable },
})
</script>
